/* ============================================
   Beelive Studio — bee-zoom-lens.js
   Desktop : loupe au survol + click-to-zoom-more
   Mobile  : tap → fullscreen pinch & pan
   ============================================ */

(function() {
  // Interrupteur global : si false, la loupe ne s'affiche pas
  window.__beeZoomEnabled = true;
  // ── 🎛️ RÉGLAGES (tout est ici) ─────────────────────
  // Niveaux de zoom desktop (loupe)
  const ZOOM_LEVELS = [
    { zoom: 2.5, width: 380, height: 230 },
    { zoom: 3.5, width: 500, height: 300 },
    { zoom: 5,   width: 620, height: 380 }
  ];

  const LENS_BORDER  = 2;
  const LENS_RADIUS  = 12;
  const LENS_COLOR   = '#C7801D';
  const LENS_BG      = '#F5F3E7';
  const HD_WIDTH     = 3000;
  const FADE_MS      = 150;
  const RESIZE_MS    = 200;
  const HINT_DEFAULT = 'Clic gauche pour zoomer +';
  const HINT_MAX     = 'Clic pour revenir au zoom initial';

  // Mobile (pinch-zoom fullscreen)
  const MOBILE_MAX_SCALE  = 5;       // zoom max au pincement
  const MOBILE_MIN_SCALE  = 1;       // zoom min (= taille fit-to-screen)
  const MOBILE_HINT_TEXT  = 'Pincez pour zoomer · double-tap pour réinitialiser';
  const MOBILE_HINT_FADE  = 2500;    // durée d'affichage du hint (ms)
  const MOBILE_BG = '#F5F3E7';
  // ───────────────────────────────────────────────────

  function computeHiResUrl(src) {
    if (/_\d+x\./.test(src)) {
      return src.replace(/_\d+x\./, '_' + HD_WIDTH + 'x.');
    }
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/([?&]width=)\d+/, '$1' + HD_WIDTH);
    }
    return src;
  }

  // ════════════════════════════════════════════
  // DESKTOP : loupe au survol
  // ════════════════════════════════════════════
  function initDesktop(img) {
    const wrap = img.parentElement;
    if (!wrap) return;
    if (getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }

    let levelIndex = 0;
    let level = ZOOM_LEVELS[0];

    const lens = document.createElement('div');
    lens.className = 'bee-zoom-lens';
    Object.assign(lens.style, {
      position: 'absolute',
      width: level.width + 'px',
      height: level.height + 'px',
      border: LENS_BORDER + 'px solid ' + LENS_COLOR,
      borderRadius: LENS_RADIUS + 'px',
      backgroundRepeat: 'no-repeat',
      backgroundColor: LENS_BG,
      pointerEvents: 'none',
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
      opacity: '0',
      transition: 'opacity ' + FADE_MS + 'ms ease, width ' + RESIZE_MS + 'ms ease, height ' + RESIZE_MS + 'ms ease',
      zIndex: '4'
    });
    wrap.appendChild(lens);

    const hint = document.createElement('div');
    Object.assign(hint.style, {
      position: 'absolute',
      pointerEvents: 'none',
      fontSize: '11px',
      fontFamily: 'inherit',
      fontWeight: '500',
      color: '#fff',
      background: 'rgba(199,128,29,0.95)',
      padding: '5px 10px',
      borderRadius: '6px',
      opacity: '0',
      transition: 'opacity ' + FADE_MS + 'ms ease',
      whiteSpace: 'nowrap',
      zIndex: '5',
      letterSpacing: '0.2px'
    });
    hint.textContent = HINT_DEFAULT;
    wrap.appendChild(hint);

    img.style.cursor = window.__beeZoomEnabled ? 'zoom-in' : 'default';

    function refreshBgSource() {
      lens.style.backgroundImage = 'url("' + computeHiResUrl(img.src) + '")';
    }
    refreshBgSource();

    function applyLevel() {
      lens.style.width = level.width + 'px';
      lens.style.height = level.height + 'px';
    }

    function updateHintText() {
      const isMax = levelIndex === ZOOM_LEVELS.length - 1;
      hint.textContent = isMax ? HINT_MAX : HINT_DEFAULT;
    }

    function resetZoom() {
      levelIndex = 0;
      level = ZOOM_LEVELS[0];
      img.style.cursor = 'zoom-in';
      applyLevel();
      updateHintText();
    }

    function render(e) {
      if (!window.__beeZoomEnabled) { lens.style.opacity = '0'; hint.style.opacity = '0'; return; }
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        lens.style.opacity = '0';
        hint.style.opacity = '0';
        return;
      }
      const wrapRect = wrap.getBoundingClientRect();
      const offX = rect.left - wrapRect.left;
      const offY = rect.top - wrapRect.top;

      lens.style.backgroundSize =
        (img.offsetWidth * level.zoom) + 'px ' + (img.offsetHeight * level.zoom) + 'px';
      lens.style.opacity = '1';
      lens.style.left = (offX + x - level.width / 2) + 'px';
      lens.style.top  = (offY + y - level.height / 2) + 'px';

      const bgX = -(x * level.zoom - level.width / 2 + LENS_BORDER);
      const bgY = -(y * level.zoom - level.height / 2 + LENS_BORDER);
      lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';

      hint.style.opacity = '1';
      hint.style.left = (offX + x - hint.offsetWidth / 2) + 'px';
      hint.style.top  = (offY + y + level.height / 2 + 6) + 'px';
    }

    img.addEventListener('mousemove', render);

    img.addEventListener('mouseleave', function() {
      lens.style.opacity = '0';
      hint.style.opacity = '0';
    });

    wrap.addEventListener('mouseleave', function() {
      resetZoom();
    });

    img.addEventListener('click', function(e) {
      if (!window.__beeZoomEnabled) return;
      levelIndex = (levelIndex + 1) % ZOOM_LEVELS.length;
      level = ZOOM_LEVELS[levelIndex];
      img.style.cursor = (levelIndex === ZOOM_LEVELS.length - 1) ? 'zoom-out' : 'zoom-in';
      applyLevel();
      updateHintText();
      render(e);
    });

    new MutationObserver(function() {
      refreshBgSource();
      resetZoom();
    }).observe(img, { attributes: true, attributeFilter: ['src'] });
  }

  // ════════════════════════════════════════════
  // MOBILE : tap → fullscreen pinch & pan
  // ════════════════════════════════════════════
  function initMobile(img) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function(e) {
      if (!window.__beeZoomEnabled) return;
      e.preventDefault();
      e.stopPropagation();
      openMobileViewer(computeHiResUrl(img.src), img.alt || '');
    });
  }

  function openMobileViewer(src, alt) {
    const overlay = document.createElement('div');
    Object.assign(overlay.style, {
      position: 'fixed',
      top: '0', left: '0',
      width: '100vw', height: '100vh',
      background: MOBILE_BG,
      zIndex: '99999',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      touchAction: 'none',
      userSelect: 'none',
      WebkitUserSelect: 'none'
    });

    const img = document.createElement('img');
    img.src = src;
    img.alt = alt;
    img.draggable = false;
    Object.assign(img.style, {
      maxWidth: '100%',
      maxHeight: '100%',
      transformOrigin: 'center center',
      transition: 'transform 0.15s ease',
      userSelect: 'none',
      WebkitUserDrag: 'none'
    });

    const closeBtn = document.createElement('button');
    closeBtn.setAttribute('aria-label', 'Fermer');
    closeBtn.innerHTML = '✕';
    Object.assign(closeBtn.style, {
      position: 'absolute',
      top: '16px', right: '16px',
      width: '44px', height: '44px',
      borderRadius: '50%',
      border: 'none',
      background: '#293947',
      color: '#fff',
      fontSize: '18px',
      cursor: 'pointer',
      zIndex: '1'
    });

    const hint = document.createElement('div');
    hint.textContent = MOBILE_HINT_TEXT;
    Object.assign(hint.style, {
      position: 'absolute',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(199,128,29,0.95)',
      color: '#fff',
      padding: '8px 14px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: '500',
      transition: 'opacity 0.4s ease',
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      maxWidth: '90vw',
      textAlign: 'center'
    });

    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    overlay.appendChild(hint);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    // ── Bouton Retour natif = ferme le zoom (revient à la lightbox) ──
    let zoomClosed = false;
    function destroyViewer() {
      if (zoomClosed) return;
      zoomClosed = true;
      window.__beeZoomOpen = false;
      window.removeEventListener('popstate', onZoomPop);
      overlay.remove();
      document.body.style.overflow = 'hidden'; // la lightbox dessous garde le scroll bloqué
    }
    function onZoomPop() { destroyViewer(); }
    function closeViewer() {
      if (history.state && history.state.beeZoom) history.back(); // → popstate → destroyViewer
      else destroyViewer();
    }
    window.__beeZoomOpen = true;
    history.pushState({ beeZoom: true }, '');
    window.addEventListener('popstate', onZoomPop);

    setTimeout(function() { hint.style.opacity = '0'; }, MOBILE_HINT_FADE);

    // ── État pinch + pan ──
    let scale = 1, translateX = 0, translateY = 0;
    let startDistance = 0, startScale = 1;
    let lastX = 0, lastY = 0;
    let mode = null;
    let lastTapTime = 0;

    function applyTransform(animate) {
      img.style.transition = animate ? 'transform 0.2s ease' : 'none';
      img.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')';
    }

    function getDistance(t1, t2) {
      const dx = t2.clientX - t1.clientX;
      const dy = t2.clientY - t1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    // ✅ Clamp INSIDE openMobileViewer — accès à img, scale, translateX/Y
    function clampTranslate() {
      if (scale <= 1) {
        translateX = 0;
        translateY = 0;
        return;
      }
      const renderedW = img.offsetWidth * scale;
      const renderedH = img.offsetHeight * scale;
      const maxTx = Math.max(0, (renderedW - window.innerWidth) / 2);
      const maxTy = Math.max(0, (renderedH - window.innerHeight) / 2);
      translateX = Math.max(-maxTx, Math.min(maxTx, translateX));
      translateY = Math.max(-maxTy, Math.min(maxTy, translateY));
    }

    function close() {
      overlay.remove();
      document.body.style.overflow = '';
    }

    img.addEventListener('touchstart', function(e) {
      e.preventDefault();
      if (e.touches.length === 2) {
        mode = 'pinch';
        startDistance = getDistance(e.touches[0], e.touches[1]);
        startScale = scale;
      } else if (e.touches.length === 1) {
        mode = 'pan';
        lastX = e.touches[0].clientX;
        lastY = e.touches[0].clientY;
      }
    }, { passive: false });

    img.addEventListener('touchmove', function(e) {
      e.preventDefault();
      if (mode === 'pinch' && e.touches.length === 2) {
        const dist = getDistance(e.touches[0], e.touches[1]);
        const ratio = dist / startDistance;
        scale = Math.max(MOBILE_MIN_SCALE, Math.min(MOBILE_MAX_SCALE, startScale * ratio));
        clampTranslate();
        applyTransform(false);
      } else if (mode === 'pan' && e.touches.length === 1 && scale > 1) {
        const dx = e.touches[0].clientX - lastX;
        const dy = e.touches[0].clientY - lastY;
        translateX += dx;
        translateY += dy;
        clampTranslate();
        lastX = e.touches[0].clientX;
        lastY = e.touches[0].clientY;
        applyTransform(false);
      }
    }, { passive: false });

    img.addEventListener('touchend', function() {
      mode = null;
      if (scale <= 1) {
        scale = 1;
        translateX = 0;
        translateY = 0;
        applyTransform(true);
      }
    });

    img.addEventListener('click', function() {
      const now = Date.now();
      if (now - lastTapTime < 300) {
        if (scale > 1) {
          scale = 1; translateX = 0; translateY = 0;
        } else {
          scale = 2.5;
        }
        applyTransform(true);
      }
      lastTapTime = now;
    });

    closeBtn.addEventListener('click', closeViewer);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeViewer();
    });
  }

  // ════════════════════════════════════════════
  // Routeur : desktop ou mobile selon le device
  // ════════════════════════════════════════════
  function init(img) {
    if (!img || img.dataset.beeZoomInit === '1') return;
    img.dataset.beeZoomInit = '1';

    if (matchMedia('(hover: none)').matches) {
      initMobile(img);
    } else {
      initDesktop(img);
    }
  }

  function autoInit() {
    document.querySelectorAll('img[data-bee-zoom]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

  window.beeZoomLens = { init: init };
})();